"use client";

import type { ComponentProps } from "react";
import { SeriesScoreEditor } from "./series-score-editor";

type TennisScoreEditorProps = {
  initialData?: Record<string, unknown> | null;
  maxDetailCount?: number;
  onChange: (data: Record<string, unknown>) => void;
} & Pick<
  ComponentProps<typeof SeriesScoreEditor>,
  "team1Label" | "team2Label" | "totalMax"
>;

export function TennisScoreEditor({
  initialData,
  onChange,
  maxDetailCount = 9,
  team1Label,
  team2Label,
  totalMax,
}: TennisScoreEditorProps) {
  return (
    <SeriesScoreEditor
      matchScoreLabel="Match Score (Sets Won)"
      detailsLabel="Set Details (Optional)"
      detailsHint="Enter games per set. Sets won are auto-calculated."
      unitSingularLabel="Set"
      matchScoreKeys={{ your: "yourSets", opponent: "opponentSets" }}
      detailsKey="sets"
      initialData={initialData}
      maxDetailCount={maxDetailCount}
      detailMaxScore={7}
      team1Label={team1Label}
      team2Label={team2Label}
      totalMax={totalMax}
      onChange={onChange}
    />
  );
}
